export const ModuleTypes = {
  GROCERY: "grocery",
  PHARMACY: "pharmacy",
  ECOMMERCE: "ecommerce",
  FOOD: "food",
  PARCEL: "parcel",
  LIQUOR: "liquor",
};
